export interface HotItem {
  id: number;
  rank: number;
  title: string;
  tag: string;
  heat: string;
  floors: string;
  up: boolean;
}

export interface Story {
  id: number;
  cat: string;
  title: string;
  desc: string;
  status: string;
  latestTime: string;
  floorCount: string;
  todayNew: number;
  followers: string;
  icon: string;
}

export interface Floor {
  no: number;
  author: string;
  time: string;
  content: string;
  votes: number;
  tag?: string;
}

export const cats = [
  "全部瓜田",
  "综艺瓜",
  "影视瓜",
  "热搜瓜",
  "塌房预警",
  "圈内人设",
  "实锤复盘",
];

export const hotList: HotItem[] = [
  { id: 1, rank: 1, title: "《舞台请就位》决赛夜彩排花絮流出，红毯站位疑引热议", tag: "综艺瓜", heat: "1863万", floors: "3.2万楼", up: true },
  { id: 2, rank: 2, title: "古装剧《长安灯火》深夜九宫格，官微被疑暗示定档", tag: "影视瓜", heat: "1502万", floors: "2.6万楼", up: true },
  { id: 3, rank: 3, title: "头部直播间「优惠券口径」争议发酵，评论区蹲一纸声明", tag: "热搜瓜", heat: "1287万", floors: "1.9万楼", up: true },
  { id: 4, rank: 4, title: "顶流演唱会应援位定价争议，主办方承诺今日回应", tag: "热搜瓜", heat: "1094万", floors: "1.5万楼", up: true },
  { id: 5, rank: 5, title: "《笑声实验室》踢馆名单疑泄露，节目组未置可否", tag: "综艺瓜", heat: "863万", floors: "1.1万楼", up: false },
  { id: 6, rank: 6, title: "新剧片花台词似曾相识，原作者深夜只发一个省略号", tag: "实锤复盘", heat: "741万", floors: "8900楼", up: true },
];

export const stories: Story[] = [
  {
    id: 1,
    cat: "综艺瓜",
    title: "《舞台请就位》决赛夜彩排花絮流出",
    desc: "流出的彩排片段里导师红毯站位与成片不同，网友怀疑剪辑顺序另有安排，正在蹲完整版与节目组说法。",
    status: "有新进展",
    latestTime: "12 分钟前更新",
    floorCount: "3.2 万",
    todayNew: 632,
    followers: "4.8 万人在蹲",
    icon: "ri-tv-2-line",
  },
  {
    id: 2,
    cat: "影视瓜",
    title: "古装剧《长安灯火》深夜发九宫格",
    desc: "官微凌晨连发九张剧照并配一句「灯火渐明」，被剧迷解读为档期预热，正蹲今晚是否正式官宣。",
    status: "持续跟进",
    latestTime: "1 小时前更新",
    floorCount: "2.6 万",
    todayNew: 418,
    followers: "3.1 万人在蹲",
    icon: "ri-movie-2-line",
  },
  {
    id: 3,
    cat: "热搜瓜",
    title: "「优惠券口径」争议，蹲一纸正式声明",
    desc: "关于活动优惠券使用条件的两种说法在评论区各执一词，客服口径前后不一，楼友正蹲官方统一回应。",
    status: "蹲帖中",
    latestTime: "3 小时前更新",
    floorCount: "1.9 万",
    todayNew: 275,
    followers: "2.2 万人在蹲",
    icon: "ri-price-tag-3-line",
  },
  {
    id: 4,
    cat: "热搜瓜",
    title: "演唱会应援位定价争议，等主办方回应",
    desc: "分区票价与应援位名额被指不对等，粉丝整理成楼层时间线并@主办方，承诺「今日内」答复正在倒计时。",
    status: "蹲帖中",
    latestTime: "2 小时前更新",
    floorCount: "1.5 万",
    todayNew: 198,
    followers: "1.9 万人在蹲",
    icon: "ri-vip-crown-line",
  },
  {
    id: 5,
    cat: "综艺瓜",
    title: "《笑声实验室》踢馆名单疑遭泄露",
    desc: "一张后台表被晒出，疑似新一期踢馆阵容，官方对此既不承认也不否认，评论区在讨论可信度。",
    status: "已有线索",
    latestTime: "5 小时前更新",
    floorCount: "1.1 万",
    todayNew: 143,
    followers: "1.3 万人在蹲",
    icon: "ri-emotion-laugh-line",
  },
  {
    id: 6,
    cat: "实锤复盘",
    title: "新剧片花台词似曾相识，原作者深夜发文",
    desc: "片花中的一句对白被指与旧文高度相似，原作者深夜只发了一个省略号，网友正对照逐帧复盘。",
    status: "有待后续",
    latestTime: "昨天更新",
    floorCount: "8900",
    todayNew: 66,
    followers: "1.1 万人在蹲",
    icon: "ri-file-search-line",
  },
];

export const timeline = {
  story: stories[0],
  summary: "「舞台请就位」决赛夜之后，导师红毯站位与成片顺序的差异成为焦点。这条楼的盖楼过程，就是这场瓜的最新进度。",
  floors: [
    { no: 1, author: "搬瓜工小乙", time: "昨晚 22:14", content: "彩排直播切了一帧，导师站位跟正片完全不同，先占个楼，蹲剪辑原委。", votes: 3280, tag: "首发现场" },
    { no: 12, author: "夜猫子蹲帖", time: "昨晚 23:02", content: "放大看了站位图，成片里 A 和 B 换了个位，中间还夹了段空白，剪辑明显动过。", votes: 2150 },
    { no: 35, author: "细节党", time: "今天 00:47", content: "掐到后面观众区灯牌，实时亮的是 C 家应援，但正片给到镜头的是另一边，逻辑对不上。", votes: 1890, tag: "楼中锤" },
    { no: 58, author: "糊弄学十级", time: "今天 02:20", content: "先别急，也可能是彩排临时换位，蹲一个官方花絮或者正片完整版再下结论。", votes: 1320 },
    { no: 74, author: "等一个说法", time: "今天 09:15", content: "节目组皮下刚上线，好几条带节奏评论被清了，看来真有人在盯这楼。", votes: 2410 },
    { no: 89, author: "吃瓜吧小编", time: "今天 11:40", content: "补充：官微已置顶「完整版稍后放出」的预告，本楼继续跟进，有新进展第一时间顶上来。", votes: 4150, tag: "官方信号" },
  ],
};

export const faqs = [
  { q: "「盖楼蹲帖」到底是什么意思？", a: "盖楼指在话题楼里一层层评论跟帖；蹲帖则是守在楼里等后续更新。吃瓜吧把同类事件聚成一条楼，你在这蹲，楼层有新进展就会往上顶。" },
  { q: "楼层跟进新进展是什么机制？", a: "每条正在蹲的瓜都有独立楼层，当出现官方声明、新物料或关键线索时，小编会把新信息整理成新楼层顶到最上方，并标注更新时间和今日新增楼层数。" },
  { q: "如何不错过我正在蹲的瓜？", a: "在「正在蹲的瓜」区块用搜索或分类筛选找到目标瓜后，记住它的楼层状态即可；同时热榜会标记「有新进展」的瓜，方便第一时间回来续蹲。" },
  { q: "楼里信息都可信吗？", a: "楼层内容按「搬瓜 / 楼中锤 / 官方信号」等标签标注来源层级，仅供参考。建议以官方声明与一手物料为准，理性吃瓜。" },
  { q: "可以自己开新楼分享线索吗？", a: "目前是围观与跟进模式。你可以在对应楼层评论区提供线索，符合规则的靠谱线索会被整理进正式楼层并署名标记。" },
];

export const testimonials = [
  { name: "楼友·一只汤圆", text: "在别处翻半天没下文，来吃瓜吧一看楼层跟得明明白白，更新也快，蹲的瓜今天出结果了。" },
  { name: "楼友·午夜电台", text: "最喜欢「官方信号」的标注，几层楼就分清什么是锤什么是猜，不瞎带节奏，很清爽。" },
  { name: "楼友·香菜不香", text: "盖楼盖着盖着蹲出连续剧，楼上几层都被时间线串起来了，比单刷热搜舒服多了。" },
  { name: "楼友·周末补觉中", text: "更新时间标得很清楚，午休刷一眼就知道刚蹲的瓜走到哪一步了，追帖不遗漏。" },
];

export const stats = [
  { value: "2.4w+", label: "瓜田总话题" },
  { value: "18w+", label: "今日新楼层" },
  { value: "520w+", label: "蹲帖楼友" },
  { value: "24h", label: "更新不掉线" },
];